/*  The Dummy logger is temporary until Beta and Prod APIs are setup
    and to aviod additional filtering logic in every place the logger is used.
    It will still be used for the adams and baker stages until they are depricated. */
class DummyLogger {
    addPerformanceListener () {
        return
    }

    addErrorListener () {
        return
    }

    debug (param1, param2) {
        return
    }

    info (param1, param2) {
        return
    }

    warn (param1, param2) {
        return
    }

    error (param1, param2) {
        return
    }

    fatal (param1, param2) {
        return
    }
}

export default DummyLogger
